import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const getAllCollaborators = createAsyncThunk('getAllCollaborators', async (_, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/drive/collaborators`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const collaboratorSlice = createSlice({
    name: 'collaboratorSlice',
    initialState: {
        loading: false,
        collaborators: [],
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(getAllCollaborators.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getAllCollaborators.fulfilled, (state, action) => {
            state.loading = false;
            state.collaborators = action.payload
        })
        builder.addCase(getAllCollaborators.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default collaboratorSlice.reducer